import { FEATURE_FLAG_DEFAULTS } from '../featureFlags';

export const TENANT_MOCK_DATA = {
  identifier: '1630524006',
  pipelineId: 46,
  branch: 'dev6',
  name: 'Tenant 1630524006',
  webAppUrl: 'https://www.google.com',
  googleAnalyticsId: 'GA-12345',
  homePageConfiguration: {
    branding: {
      brandingType: 'generic',
    },
    siteName: 'DEV HSF',
    programLongName: 'Test',
    programShortName: 'TST',
    signInMessage:
      '<p>Sign up or sign in to access</p><p><br></p><ul><li>Complete your scholarship application</li></ul><p><br></p><ul><li>Connect with the Cheech Marin Scholarship Team</li></ul>',
    fontFamilyName: 'PT Sans,sans-serif',
  },
  brandingDetailsConfiguration: {
    primaryColor: '',
    secondaryColor: '',
  },
  readerConfiguration: {
    maxReadsByReader: 5,
    requiredReads: 1,
    diverseEthnicity: true,
  },
  featuresConfiguration: { ...FEATURE_FLAG_DEFAULTS },
  donationPageConfiguration: {
    isCtaVisible: false,
  },
  fundsDisbursement: 'student',
  legalConfiguration: {
    copyrightLanguage: '<p>This is a copyright</p>',
    privacyPolicy: '<p>privacy policy</p>',
  },
  bannerConfiguration: {
    isBannerEnabled: false,
    title: '',
    description: '',
  },
  databaseConfiguration: {
    hostName: 'non-prod-hsf.cci5ve8kwd07',
    databaseName: 'hsf',
    username: 'postgres',
    password: 'password',
  },
  sendGridConfiguration: {
    apiKey: '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',
    senderEmail: 'noreply@hsfts.net',
    templates: [
      {
        key: 'VERIFICATION_EMAIL_TEMPLATE_ID',
        templateId: 'd-a5f59a9d2ecd42578572ebb2857878f7',
      },
    ],
  },
  twilioConfiguration: {
    authToken: '330e59e8078d853450a3716cd98f810d',
    accountSid: 'AC996eb8aa30d9ac1b20e2112198cc037f',
    phoneNumber: '2135312281',
  },
};
